// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'fx-customer-rates/archive',
        component: () =>
            import(
                /* webpackChunkName: "settings.fx-customer-rates" */
                '@/pages/[organisation]/settings/fx-customer-rates/archive.vue'
            ),
        name: 'settings.fx-customer-rates.archived-fx-customer-rates',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.foreign-currency.update-fx-customer-rate',
        },
    },
    {
        path: 'fx-customer-rates/archive/:id',
        component: () =>
            import(
                /* webpackChunkName: "settings.fx-customer-rates" */
                '@/pages/[organisation]/settings/fx-customer-rates/archive/[id].vue'
            ),
        name: 'settings.fx-customer-rates.view-archived-fx-customer-rate',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.foreign-currency.update-fx-customer-rate',
        },
    },
    {
        path: 'fx-customer-rates',
        component: () =>
            import(
                /* webpackChunkName: "settings.fx-customer-rates" */
                '@/pages/[organisation]/settings/fx-customer-rates.vue'
            ),
        name: 'settings.fx-customer-rates.search-fx-customer-rates',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.foreign-currency.view-fx-customer-rates',
        },
    },
    {
        path: 'fx-customer-rates/new',
        component: () =>
            import(
                /* webpackChunkName: "settings.fx-customer-rates" */
                '@/pages/[organisation]/settings/fx-customer-rates/new.vue'
            ),
        name: 'settings.fx-customer-rates.create-fx-customer-rate',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.foreign-currency.create-fx-customer-rate',
        },
    },
    {
        path: 'fx-customer-rates/:id',
        component: () =>
            import(
                /* webpackChunkName: "settings.fx-customer-rates" */
                '@/pages/[organisation]/settings/fx-customer-rates/[id].vue'
            ),
        name: 'settings.fx-customer-rates.view-fx-customer-rate',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.foreign-currency.view-fx-customer-rates',
        },
    },
    {
        path: 'fx-customer-rates/:id/edit',
        component: () =>
            import(
                /* webpackChunkName: "settings.fx-customer-rates" */
                '@/pages/[organisation]/settings/fx-customer-rates/[id]/edit.vue'
            ),
        name: 'settings.fx-customer-rates.update-fx-customer-rate',
        meta: {
            loginRequired: true,
            permission: 'access.accounting.foreign-currency.update-fx-customer-rate',
        },
    },
];
